import React from 'react'
import { Link } from 'react-router'
import { get, omit, join, isNull } from 'lodash'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import IndexComponent from '../common/IndexComponent'
import indexActions from '../../actions/LifeBenefitsSets'
import platformActions from '../../actions/Platforms'
import connectIndex from '../../lib/connectIndex'
import { BenefitsSetIndex } from '../BenefitsSet/BenefitsSetIndex'
import BenefitsSetsHelper from '../BenefitsSet/Helpers/BenefitsSetsHelper'
import approvalStateDisplay from '../BenefitsSet/approvalStateDisplay'
import publishStateDisplayWithModal from '../BenefitsSet/publishStateDisplayWithModal'
import exportActions from '../../actions/BenefitsSetsExports'
import ratesStatusDisplay from '../BenefitsSet/ratesStatusDisplay'

export class LifeBenefitsSetIndex extends Component {
  static propTypes = {
    ...omit(BenefitsSetIndex.propTypes, 'productLine')
  }

  static serviceAreaLinkDisplay = (record) => {
    if (!isNull(record.howie_service_area_name)) { return record.service_area_name }

    return (
      <Link
        title={record.service_area_name}
        to={`/ancillary_service_areas/${record.service_area_id}`}
      >
        {record.service_area_name}
      </Link>
    )
  }

  render() {
    return (
      <div>
        <BenefitsSetIndex
          {...this.props}
          name="Life Benefits Set"
          columnsList={columnsList}
          includeBulkEditLink
          includeDiffSetLink
          includeSelectAll
          includeNewRecordLink
          searchPlaceholder="Search by Name, Hios ID, Document or Rate Factor Set ID"
          searchColumns={['name', 'hios_id', 'issuer_id', 'document_id', 'rate_factor_set_id', 'service_area_id']}
          productLine="life"
        />
      </div>
    )
  }
}

const filters = [
  {
    key: 'audience',
    config: 'benefits.audience'
  },
  {
    key: 'approval_state',
    options: [
      { value: 'new', text: 'New' },
      { value: 'approved', text: 'Approved' },
      { value: 'rejected', text: 'Rejected' },
      { value: 'corrected', text: 'Corrected' },
      { value: 'amended', text: 'Amended' }
    ]
  },
  {
    key: 'publish_state',
    options: [
      { value: 'needs_publishing', text: 'Needs Publishing' },
      { value: 'failed_to_publish', text: 'Failed to publish' },
      { value: 'published', text: 'Published' },
      { value: 'unpublished', text: 'Unpublished' },
      { value: 'publishing', text: 'Publishing' }
    ]
  },
  {
    key: 'plan_years',
    options: BenefitsSetsHelper.planYearOptions(2015, (new Date()).getFullYear() + 1)
  },
  {
    key: 'ancillary_privileged_platforms',
    path: 'platforms.index',
    actions: {
      records: platformActions.index.main,
      reset: platformActions.index.reset
    }
  },
  {
    key: 'states',
    options: (state) => {
      return state.login.session.configuration.states.map((s) => {
        return { text: s.text, value: s.name }
      })
    }
  }
]

const columnsList = [
  { key: 'name', label: 'Name', display: BenefitsSetIndex.showLinkDisplay('/life_benefits') },
  {
    key: 'states',
    label: 'States',
    sortable: false,
    filterable: true,
    recordValue: 'value',
    recordLabel: 'text'
  },
  { key: 'issuer_name', label: 'Issuer' },
  { key: 'issuer_id', label: 'Issuer ID' },
  { key: 'vericred_id', label: 'Vericred ID', sortable: false },
  {
    key: 'ancillary_privileged_platforms',
    label: 'Platforms',
    recordValue: 'name',
    sortable: false,
    filterable: true,
    display: (value) => {
      return join(get(value, 'ancillary_privileged_platforms'), ', ')
    }
  },
  {
    key: 'audience',
    label: 'Audience',
    filterable: true,
    optionsEnum: true
  },
  {
    key: 'plan_years',
    label: 'Years',
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value',
    display: (value) => {
      return join(get(value, 'plan_years'), ', ')
    }
  },
  { key: 'updated_at', label: 'Last Updated At', display: IndexComponent.dateTimeDisplay },
  { key: 'last_updated_by_username', label: 'Last Updated By' },
  {
    key: 'approval_state',
    label: 'Status',
    display: approvalStateDisplay,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'publish_state',
    label: 'Publish Status',
    display: publishStateDisplayWithModal,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  }
]

const ipaViewColumnsList = [
  { key: 'vericred_id', label: 'Vericred ID', sortable: false },
  { key: 'issuer_id', label: 'Issuer ID' },
  {
    key: 'audience',
    label: 'Audience',
    filterable: true,
    optionsEnum: true
  },
  {
    key: 'plan_years',
    label: 'Years',
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value',
    display: (value) => {
      return join(get(value, 'plan_years'), ', ')
    }
  },
  {
    key: 'name',
    label: 'Name',
    display: BenefitsSetIndex.showLinkDisplay('/life_benefits')
  },
  {
    key: 'states',
    label: 'States',
    sortable: false,
    filterable: true,
    recordValue: 'value',
    recordLabel: 'text'
  },
  {
    key: 'publish_state',
    label: 'Publish Status',
    display: publishStateDisplayWithModal,
    filterable: true,
    recordLabel: 'text',
    recordValue: 'value'
  },
  {
    key: 'service_area_name',
    label: 'Service Area',
    display: LifeBenefitsSetIndex.serviceAreaLinkDisplay
  },
  {
    key: 'rate_factor_set_name',
    label: 'Rate Factor Set',
    display: BenefitsSetIndex.showRateFactorSetLinkDisplay
  },
  {
    key: 'ancillary_rate_factor_set_status',
    label: 'Rates Status',
    display: ratesStatusDisplay,
    recordLabel: 'text',
    recordValue: 'value'
  }
]

export default connectIndex(
  withRouter(LifeBenefitsSetIndex),
  'lifeBenefitsSets',
  indexActions,
  filters,
  {
    benefitsSetPath: '/life_benefits',
    ipaViewColumnsList
  },
  [
    { action: exportActions.create.main, key: 'createBenefitsSetExport' },
    { action: exportActions.create.reset, key: 'resetCreateBenefitsSetExport' }
  ],
  [
    { key: 'benefitsSetExport', reducer: 'benefitsSetsExports', action: 'create' }
  ]
)

